/*
 * @Author: your name
 * @Date: 2021-06-04 14:16:02
 * @LastEditTime: 2022-12-15 21:49:17
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\realTimeAlarm\api\index.js
 */
export const api = {
  list: '/cms/account/queryAssociationalDeviceTree.json', // 获取区域
  getIndoorDeviceList: "/cms/building/queryDeviceListByBuilding.json", //查询室内设备信息,
  addPersonnelBwlist: "/vas/bwlist/addPersonnelBwlist.json", //新增名单
  queryGroup: "/vas/faceGroup/queryFaceGroupByType.json", //查询名单组
  querySceneDetail: "/bms/devicescene/queryDeviceSceneDetail.json", //获取场景详情
  controlPlayAudio: "/bas/remotecall/controlPlayAudio.json", // 控制音频播放（上一首、下一首、播放、暂停）
  playAudio: "/bas/remotecall/playAudio.json", // 创建音频播放
  queryAudio: "/bms/audiomanagement/queryAudioApi.json", // 查询音频文件列表-公用
  searchCarDraw: " /vas/vehicleSearching/searchVehicleTrail.json", //车辆轨迹
  queryPlayAudio: "/bas/remotecall/queryPlayAudio.json", // 查询音频播放
  searchPeopleDraw:
    " /vas/personnelControl/personnelSearching/peopleTrackDetails.json", //人员轨迹
  deletePlayAudio: "/bas/remotecall/deletePlayAudio.json", // 删除音频播放
  queryBuildingList: "/cms/building/queryBuildingList.json", //查询楼栋楼层list
  getPersonRecordList:
    "/bas/turnstilegate/queryTurnstilegateTrafficRecordList.json", // 获取人员通行记录列表
  getVehicleRecordList:
    "/bas/vehicleBarrier/queryVehicleBarrierTrafficRecordList.json",
  getVehicleRecordListNew:
    "/bas/vehicleHisRecord/queryVehicleHisRecordList",
  queryDeviceSceneList: "/bms/devicescene/queryDeviceSceneList.json", //出入口场景
  queryDeviceSceneDetail: "/bms/devicescene/queryDeviceSceneDetail.json", //详情
  queryAreaDeviceTree: "/bms/device/queryAreaDeviceTree.json", // 查询设备树
  queryDeviceWorkGroupDeviceTree:
    "/bms/device/queryDeviceWorkGroupDeviceTree.json", // 查询广播
  queryRemoteCall: "/bas/remotecall/queryRemoteCall.json", // 查询远程喊话
  deleteRemoteCall: "/bas/remotecall/deleteRemoteCall.json", // 删除远程喊话

  manualRemoteCall: "/bas/remotecall/manualRemoteCall.json", // 创建远程喊话
  common: {
    batchFileload: "/common/file/batchFileload.json" //图片上传
  },
  alarm: {
    getAlarmDetail: "/bas/alarmSafeEvent/queryResult.json", // 获取告警详情
    getAlarmPageList: "/bas/alarmSafeEvent/queryResultsByPage.json", // 安全事件告警筛选
    updateAlarm: "/bas/alarmSafeEvent/updateSafeEvent.json", // 安全事件告警处理
    missReport: "/bas/alarmSafeEvent/missReport.json", // 误报
    batchMissReport: "/bas/alarmSafeEvent/updateMergeMisinformationAlarm.json", // 批量误报
    queryAlarmMergeAlarmList:
      "/bas/alarmSafeEvent/queryAlarmMergeAlarmList.json", // 获取合并列表
    queryAlarmDeviceList: "/bas/alarmSafeEvent/queryAlarmDeviceList.json", // 获取告警周边设备
    queryQuickLabelList: "/common/quicklabel/queryQuickLabelList.json" // 查询快捷标签列表
  },
  historyAlarm: {
    sreachAlarm: "/bas/safeEvent/sreachAlarmDetails.json" // 历史告警筛选
  },
  bms: {
    upDeviceCoords: "/bms/device/updateDeviceLocation.json", // 修改摄像机设备坐标
    getDeviceTypeList: "/bms/device/getDeviceTypeListByPage.json", // 获取设备类型
    // queryMapResource: '/bms/device/queryResource.json' // 返回地图展示的资源数据
    queryMapResource: "/bms/device/queryDeviceListByType.json",
    // 公共接口
    getDeviceListByPage: "/bms/device/getDeviceListByPageApi.json", // 查询设备列表
    queryMapResources: "/bms/device/queryMapResources.json"
  },
  bas: {
    queryTaskInfo: "/bas/taskcenter/queryTaskInfo.json",
    queryLocationList: "bas/taskcenter/queryLocationList.json", // 查询当日在线保卫人员位置信息
    operateAlarm: "/bas/safeEvent/operateAlarm.json", // 创建手动告警
    addTaskInfo: "/bas/taskcenter/addTaskInfoApi.json", // 任务下发
    queryRelevantDevList: "/bas/linkage/queryRelevantDevList.json",
    queryLinkedDevList: "/bas/linkage/queryLinkedDevList.json",
    cancelAssociation: "/bas/linkage/cancelAssociation.json", //
    fastLinkage: "/bas/linkage/fastLinkage.json", // 配置快速联动
    picStreamInfo: "/bas/safeEvent/picStreamInfo.json",
    getBigPicture: "/bas/safeEvent/getPictureStream.json", //获取实时告警抓拍大图(仅人员黑白名单，车辆黑名单)
    getAlarmTypeAndSubsystem:
      "/bas/alarmSafeEvent/queryAlarmTypeAndSubsystem.json", //获取子系统及高级类型级联数据
    addAlarmFunctionConfig: "/bas/alarmSafeEvent/addAlarmFunctionConfig.json", //告警合并
    deleteAlarmFunctionConfig:
      "/bas/alarmSafeEvent/deleteAlarmFunctionConfig.json" //告警合并取消
  },
  fire: {
    getDeviceDetail: "/bms/device/queryDeviceDetails.json", //查询设备信息
    getDeviceVideo: "/bms/device/queryFirefightingCameraList.json", //查询设备视频
    checkPassword: "/bas/firefightcontrol/checkDeviceUnlockPassword.json", //控制器解密
    // controlFirefighting: '/bas/firefightcontrol/controlFirefighting.json', //;联防控制器
    controlFirefighting: "/bas/firefightcontrol/controlFirefightingApi.json", //;联防控制器
    queryFirefightingControlReply:
      "/bas/firefightcontrol/queryFirefightingControlReply.json", // 查询控制器回调
    queryFireFightingOperationConfigList:
      "/bms/device/queryFireFightingOperationConfigListApi.json", // 查询一键操作
    queryFireDeviceList: "/bms/device/queryFireDeviceListApi.json" // 查询消防设备
  },
  cms: {
    queryAccGroup: "/cms/accountGroup/queryResultsByPage.json", // 查询账户组信息
    getArea: "/cms/area/queryAreaByAccountName.json", // 查询关联区域
    getGroups: "/cms/account/queryRlatAcctGroup.json", // 根据账户查账户组
    getAccount: "/cms/accountGroup/getAccountByAccountGroup.json",
    addAlarmIgnoreConfig: "/cms/accessportal/addAlarmIgnoreConfig.json", //添加告警抑制
    queryAlarmIgnoreConfigInfo:
      "/cms/accessportal/queryAlarmIgnoreConfigInfo.json" //查寻告警抑制
  },
  reserve: {
    // 查询预案管理列表
    getEmergencyPlanList: "bas/emergency/getEmergencyPlanList.json",
    // 新增预案管理
    addEmergencyPlan: "bas/emergency/addEmergencyPlan.json",
    // 修改预案管理
    updateEmergencyPlan: "bas/emergency/updateEmergencyPlan.json",
    // 删除预案管理
    deleteEmergencyPlan: "bas/emergency/deleteEmergencyPlan.json",
    // 预案管理启动/禁用
    startOrStopEmergencyPlan: "bas/emergency/startOrStopEmergencyPlan.json",
    // 查看预案步骤列表
    getPlanStepList: "bas/planStep/getPlanStepList.json",
    // 新增预案步骤
    addPlanStep: "bas/planStep/addPlanStep.json",
    // 删除预案步骤
    deletePlanStep: "bas/planStep/deletePlanStep.json",
    // 查询告警类型树
    queryAlarmTree: "bas/emergency/queryAlarmTree.json",
    // 启动预案
    // startEmergency: '/bas/safeEvent/startEmergency.json'
    startEmergency: "/bas/emergency/addEmergencyRecord.json"
  },
  fireTruck: {
    queryFireTruckDeviceList: "/bms/device/queryFireTruckDeviceListApi.json", //查询消防车接口
    queryFireTruckGisRecord: "/vas/firetruckgis/queryFireTruckGisRecord.json" //查询消防车定位记录
  },
  setVolume: '/bas/remotecall/setVolume.json', // 设置广播设备音量
  // 设备操作类型配置
  queryConfigTypeList:
    "/bms/device/queryFireFightingOperationConfigTypeList.json", //获取操作类型列表
  addConfigTypeList: "/bms/device/addFireFightingOperationConfigType.json", //新增操作类型列表
  deleteConfigTypeList:
    "/bms/device/deleteFireFightingOperationConfigType.json", //删除操作类型列表
  updateConfigTypeList:
    "/bms/device/updateFireFightingOperationConfigType.json", //修改操作类型列表
  // 风机水泵关联
  addDeviceRelationDevice: "/bms/device/addDeviceRelationDevice.json", //新增操作类型列表
  deleteDeviceRelationDevice: "/bms/device/deleteDeviceRelationDevice.json", //删除操作类型列表
  // 步骤
  addConfigStep: "/bms/device/addFireFightingOperationConfigApi.json", //新增步骤
  updateConfigStep: "/bms/device/updateFireFightingOperationConfigApi.json", //修改步骤
  deleteConfigStep: "/bms/device/deleteFireFightingOperationConfigApi.json", //删除步骤
  // 操作设备
  controlTurnstilegate: "/bas/turnstilegate/controlTurnstilegate.json", //开关控制门--人行闸机
  controlVehicleBarrier: "/bas/vehicleBarrier/controlVehicleBarrier.json", // 控制开关--道闸
  queryRealTimeVideoRtsp: "/vas/video/queryRealTimeVideoRtsp.json",
  queryCheckPoints: "/com.cloud.isoft.graphhopperreadershp.service/getNavigationRoutesForWalk"
};
